import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initExpertsSlider = () => {
  const sliderContainer = document.querySelector("[data-experts-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    spaceBetween: 8,
    autoHeight: true,
    breakpoints: {         
      997: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },              
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },       
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    },
    pagination: {
      el: "[data-experts-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
      dynamicBullets: true,
      dynamicMainBullets: 4,
    },
    navigation: {
      nextEl: "[data-experts-slider-container] .slider-navigation__button--next",
      prevEl: "[data-experts-slider-container] .slider-navigation__button--prev",
    },
  });  
};

export default initExpertsSlider;
